import React, { useEffect, useState } from "react";
import api from "../../../../utils/api";
import "./AdminNotices.css";

const Notices = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("General");

  const [editingId, setEditingId] = useState(null);

  const fetchNotices = async () => {
    try {
      const res = await api.get("/notices");
      setNotices(res.data.data);
    } catch (err) {
      console.error("Failed to fetch notices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  const submit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        await api.put(`/notices/${editingId}`, {
          title,
          description,
          category,
        });
      } else {
        await api.post("/notices", {
          title,
          description,
          category,
        });
      }

      resetForm();
      fetchNotices();
    } catch (err) {
      alert("Failed to save notice");
    }
  };

  const editNotice = (notice) => {
    setEditingId(notice._id);
    setTitle(notice.title);
    setDescription(notice.description);
    setCategory(notice.category);
  };

  const toggleStatus = async (id, isActive) => {
    try {
      await api.put(`/notices/${id}`, { isActive: !isActive });
      fetchNotices();
    } catch {
      alert("Failed to update status");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Are you sure you want to delete this notice?")) return;

    try {
      await api.delete(`/notices/${id}`);
      fetchNotices();
    } catch {
      alert("Delete failed");
    }
  };

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setCategory("General");
    setEditingId(null);
  };

  if (loading) return <p>Loading notices...</p>;

  return (
    <div className="notices-container">
      <h2 className="admin-dashboard-sec-head">📢 Manage Notices</h2>

      {/* Form */}
      <form className="notice-form" onSubmit={submit}>
        <input
          placeholder="Notice Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <textarea
          placeholder="Notice Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />

        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="General">General</option>
          <option value="Exam">Exam</option>
          <option value="Event">Event</option>
        </select>

        <div className="form-actions">
          <button type="submit">
            {editingId ? "Update Notice" : "Add Notice"}
          </button>
          {editingId && (
            <button type="button" className="secondary" onClick={resetForm}>
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* List */}
      <div className="notice-list">
        {notices.length === 0 ? (
          <p className="empty">No notices found</p>
        ) : (
          notices.map((n) => (
            <div key={n._id} className="notice-card">
              <div className="notice-header">
                <h3>{n.title}</h3>
                <span className={`badge ${n.isActive ? "active" : "inactive"}`}>
                  {n.isActive ? "Active" : "Inactive"}
                </span>
              </div>

              <p>{n.description}</p>

              <div className="meta">
                <span>{n.category}</span>
                <span>
                  {new Date(n.createdAt).toLocaleDateString()}
                </span>
              </div>

              <div className="actions">
                <button onClick={() => editNotice(n)}>Edit</button>
                <button
                  onClick={() => toggleStatus(n._id, n.isActive)}
                  className="warning"
                >
                  {n.isActive ? "Deactivate" : "Activate"}
                </button>
                <button className="danger" onClick={() => remove(n._id)}>
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Notices;
